import { makeStyles } from 'tss-react/mui';
import { B2C_ERROR_BACKGROUND } from '../../config/environment';

const useStyles = makeStyles()(() => ({
  errorPage: {
    backgroundImage: `url(${B2C_ERROR_BACKGROUND})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    textAlign: 'center',
  },
  card: {
    maxWidth: '800px',
    padding: '3em',
  },
  logo: {
    width: '100px',
    margin: '0 auto',
  },
  pageTitle: {
    fontWeight: 400,
    marginBottom: '20px',
  },
  message: {
    fontWeight: 300,
    fontSize: '1.2rem',
  },
  tryAgainButton: {
    marginTop: '40px',
    padding: '10px 20px',
    backgroundColor: '#296ec6',
  },
}));

export default useStyles;
